import React from "react";
import { Text } from '@chakra-ui/react';


const NotFoundPage = () => {
  return <Text fontSize="2xl" fontWeight="bold" mb={6} textAlign="center" color="teal.500">
Page Not Found</Text>
};

export default NotFoundPage;
